import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';

import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import {
    CommonStylesRenderDirective,
} from '@features/cms-render/ui/directives/common-styles-render/common-styles-render.directive';

@Component({
    selector: 'piece-text',
    templateUrl: './piece-text.component.html',
    styleUrls: ['./piece-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class PieceTextComponent extends CommonStylesRenderDirective implements OnInit {
    @Input() public element: ContentItemTree;

    @Input() public direction: string;

    public showFullText: boolean = false;

    @HostBinding('class.text-dropdown')
    public isTextDropdownEnabled: boolean = false;

    @HostBinding('class.text-dropdown-expanded')
    public isTextDropdownExpanded: boolean;

    @HostBinding('style')
    public dropdownLines: string | undefined;

    @HostBinding('class.marquee')
    public isMarqueeTextAnimationEnabled: boolean = false;

    @HostBinding('style.--marquee-duration-desktop')
    public marqueeDurationDesktopValue: string | undefined;

    @HostBinding('style.--marquee-duration-mobile')
    public marqueeDurationMobileValue: string | undefined;

    @HostBinding('class.text-blink')
    public isBlinkActive: boolean = false;

    public toggleExpandedText: string;

    public isRtl: boolean;

    public ngOnInit(): void {
        super.setDefaultHostStyles();
        this.textDropdownEnabled();
        this.textDropdownExpanded();
        this.isDropdownLines();
        this.isToggleExpandedText();
        this.marqueeTextAnimationEnabled();
        this.blinkActive();
        this.marqueeDurations();
        this.isRtl = this.direction === 'rtl';
    }

    public fullText() {
        this.showFullText = !this.showFullText;
        this.textDropdownExpanded();
        this.isDropdownLines();
        this.isToggleExpandedText();
        if (this.element.settings?.general?.marquee) {
            this.isMarqueeTextAnimationEnabled = !this.isMarqueeTextAnimationEnabled;
        }
        if (this.element.settings?.general?.blink) {
            this.isBlinkActive = !this.isBlinkActive;
        }
    }

    public textDropdownEnabled() {
        this.isTextDropdownEnabled = !!this.element.settings?.general?.textDropdownMode?.status;
    }

    public textDropdownExpanded() {
        this.isTextDropdownExpanded = this.isTextDropdownEnabled && this.showFullText;
    }

    public isDropdownLines() {
        const dropdownStyles = `--line-clamp-desktop: ${this.element.settings?.general?.textDropdownMode?.linesSummaryDesktop};
        --line-clamp-mobile: ${this.element.settings?.general?.textDropdownMode?.linesSummaryMobile};
        --color-linear-gradient: ${this.element.settings?.styles.bgColor ? this.element.settings?.styles.bgColor : '#fff'};`;
        this.dropdownLines = this.isTextDropdownEnabled && !this.showFullText
            ? dropdownStyles
            : undefined;
    }

    public isToggleExpandedText() {
        this.toggleExpandedText = this.showFullText
            ? this.element.settings?.general?.textDropdownMode?.seeLessText ?? ''
            : this.element.settings?.general?.textDropdownMode?.seeMoreText ?? '';
    }

    public marqueeTextAnimationEnabled() {
        this.isMarqueeTextAnimationEnabled = !!this.element.settings?.general?.marquee?.marqueeStatus;
    }

    public blinkActive() {
        this.isBlinkActive = !!this.element.settings?.general?.blink;
    }

    public trackByIndex(index: number): number {
        return index;
    }

    public marqueeDurations() {
        this.marqueeDurationDesktopValue = this.element.settings?.general?.marquee?.marqueeDurationDesktop
            ? `${this.element.settings?.general?.marquee?.marqueeDurationDesktop}s`
            : '20s';
        this.marqueeDurationMobileValue = this.element.settings?.general?.marquee?.marqueeDurationMobile
            ? `${this.element.settings?.general?.marquee?.marqueeDurationMobile}s`
            : '5s';
    }
}
